import { H2 } from 'platform-components';
import { TEXT_WEIGHT } from 'platform-components/constants';
import React from 'react';

import './custom-lesson-view__name.scss';

interface Props {
    text: string | null;
}

export const CustomLessonViewName = React.memo(({ text }: Props) => {
    if (!text) {
        return null;
    }

    return (
        <div className="custom-lesson-view__name">
            <H2 weight={TEXT_WEIGHT.L}>{text}</H2>
        </div>
    );
});
